import { Injectable } from '@angular/core';
import { SwipeMenuComponent } from './swipe-menu.component';

@Injectable({providedIn: 'root'})
export class SwipeMenuService {
  swipeMenues = new Map<string, SwipeMenuComponent>();

  register(id: string, menu: SwipeMenuComponent): void {
    this.swipeMenues.set(id, menu);
  }

  deregister(id: string): void {
    this.swipeMenues.delete(id);
  }

  getMenu(id: string): SwipeMenuComponent | undefined {
    return this.swipeMenues.get(id);
  }
}
